import { Identifiable, Role, Planzone } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function getRoles(httpClient: HttpClient) {
  return (planzone: Identifiable<Planzone>) =>
    httpClient
      .sendHttpRequest<{ _embedded: { roles: Identifiable<Role>[] } }>({
        endpoint: `/roles`,
        method: HttpMethods.GET,
      })
      .then(({ _embedded }) => _embedded.roles);
}

export { getRoles };
